import {
  CreateUpdateEstimateItemDto,
  ProfileSchemaDto,
} from '../../../../common/pokCore/autogenerated/pokApiClient';
import {
  AmountFieldType,
  EstimateItemFieldsDefinition,
} from '../../../../common/pokCore/validation/estimateItemFields.definition';
import mathUtils from '../../../../utils/mathUtils';

import { getValue } from './utils';

export const calculatePurchaseFields = (
  obj: Partial<CreateUpdateEstimateItemDto>,
  schema: ProfileSchemaDto | undefined,
  item: CreateUpdateEstimateItemDto,
) => {
  if (!isPurchaseCalculation(obj)) {
    return obj;
  }

  if (obj.purchaseNetTotal !== undefined) {
    return obj;
  }

  // PurchaseNetTotal = rcPurchase * (1-purchaseDiscountPercent/100) * (1+purchaseSurchargePercent/100)
  // + purchaseTechnicalCost + purchaseBeerTax + purchasePrintingCosts + purchaseOperatingFee + purchaseBlockSurcharge + purchaseTransferCosts
  const purchaseDiscountPercent = getValue(
    obj.purchaseDiscountPercent,
    item.purchaseDiscountPercent,
    0,
  );
  const purchaseSurchargePercent = getValue(
    obj.purchaseSurchargePercent,
    item.purchaseSurchargePercent,
    0,
  );
  const purchaseTechnicalCost = getValue(
    obj.purchaseTechnicalCost,
    item.purchaseTechnicalCost,
    0,
  );
  const purchaseBeerTax = getValue(
    obj.purchaseBeerTax,
    item.purchaseBeerTax,
    0,
  );
  const purchasePrintingCosts = getValue(
    obj.purchasePrintingCosts,
    item.purchasePrintingCosts,
    0,
  );
  const purchaseOperatingFee = getValue(
    obj.purchaseOperatingFee,
    item.purchaseOperatingFee,
    0,
  );
  const purchaseBlockSurcharge = getValue(
    obj.purchaseBlockSurcharge,
    item.purchaseBlockSurcharge,
    0,
  );
  const purchaseTransferCosts = getValue(
    obj.purchaseTransferCosts,
    item.purchaseTransferCosts,
    0,
  );

  if (obj.purchaseNet !== undefined) {
    const purchaseNet = getValue(obj.purchaseNet, item.purchaseNet, 0);

    const rcPurchase = mathUtils.divide(
      purchaseNet,
      mathUtils.multiply(
        mathUtils.subtract(1, mathUtils.divide(purchaseDiscountPercent, 100)),
        mathUtils.add(1, mathUtils.divide(purchaseSurchargePercent, 100)),
      ),
    );
    obj.rcPurchase = mathUtils.round(rcPurchase, 4).toString();
  } else if (
    !schema?.purchaseNet ||
    obj.rcPurchase !== undefined ||
    obj.purchaseDiscountPercent !== undefined ||
    obj.purchaseSurchargePercent !== undefined
  ) {
    //purchaseNet = rcPurchase * (1-purchaseDiscountPercent/100) * (1+purchaseSurchargePercent/100)
    const rcPurchase = getValue(obj.rcPurchase, item.rcPurchase, 0);
    const purchaseNet = mathUtils.multiply(
      mathUtils.subtract(1, mathUtils.divide(purchaseDiscountPercent, 100)),
      mathUtils.add(1, mathUtils.divide(purchaseSurchargePercent, 100)),
      rcPurchase,
    );
    obj.purchaseNet = mathUtils.round(purchaseNet, 4).toString();
  } else {
    obj.purchaseNet = item.purchaseNet;
  }

  const purchaseNet = getValue(obj.purchaseNet, item.purchaseNet, 0);
  const purchaseNetTotal = mathUtils.add(
    mathUtils.round(purchaseNet),
    mathUtils.round(purchaseTechnicalCost),
    mathUtils.round(purchaseBeerTax),
    mathUtils.round(purchasePrintingCosts),
    mathUtils.round(purchaseOperatingFee),
    mathUtils.round(purchaseBlockSurcharge),
    mathUtils.round(purchaseTransferCosts),
  );
  obj.purchaseNetTotal = mathUtils.round(purchaseNetTotal).toString();

  if (!schema?.purchaseNet) {
    obj.purchaseNet = undefined;
  }
  if (!schema?.rcPurchase) {
    obj.rcPurchase = undefined;
  }
  return obj;
};

const isPurchaseCalculation = (obj: Partial<CreateUpdateEstimateItemDto>) => {
  if (
    !EstimateItemFieldsDefinition.amountFieldsKeys.some(
      field =>
        obj[field.name as keyof CreateUpdateEstimateItemDto] !== undefined &&
        field.type === AmountFieldType.purchase,
    ) &&
    !EstimateItemFieldsDefinition.percentageFieldsKeys.some(
      field =>
        obj[field.name as keyof CreateUpdateEstimateItemDto] !== undefined &&
        field.type === AmountFieldType.purchase,
    )
  ) {
    return false;
  }

  return true;
};
